import React from 'react';
// Mascha skins data with storyline elements
export const MaschaSkinsData = [{
  id: 'mascha-nurse',
  angel_name: 'Mascha',
  skin_name: 'Professional Nurse',
  visual_theme: 'Classic white uniform with red cross and stethoscope, outside a modern clinic',
  personality_tone: 'Caring yet authoritative, with a hint of playful strictness',
  currency_type: 'Love Tokens',
  price: 0,
  unlock_method: 'Free to view',
  status: 'Unlocked',
  rarity: 'Rare',
  time_limited: false,
  countdown: null,
  fomo_label: 'Starter Skin',
  preview_image_url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tHdphawcZdzA3vSjcPtoiS/1e.png',
  short_description: 'Let Mascha take care of you with her professional bedside manner.',
  storyline_piece: 'Chapter 1: The first time I saw him, he was lying there helpless in my clinic. His eyes followed my every move as I tended to his wounds. I could feel the tension building with each gentle touch...',
  tease_animation: 'slow-turn',
  bond_level_required: 0,
  daily_mission: null
}, {
  id: 'mascha-business',
  angel_name: 'Mascha',
  skin_name: 'Sleek Business',
  visual_theme: 'Dark fitted suit, white blouse, high-end business district at dusk',
  personality_tone: 'Confident, assertive, with subtle flirtation behind professional demeanor',
  currency_type: 'Love Tokens',
  price: 30,
  unlock_method: 'Purchase with Love Tokens or complete Daily Mission',
  status: 'Locked',
  rarity: 'Epic',
  time_limited: false,
  countdown: null,
  fomo_label: null,
  preview_image_url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fbZTt5zMC9QcFeMWCH9nJo/1c.png',
  short_description: 'Mascha means business, but pleasure is always on her agenda.',
  storyline_piece: 'Chapter 2: Our next encounter was in my office. I had to maintain my professional composure as he pitched his business proposal, but beneath the conference table, my heels gently brushed against his leg...',
  tease_animation: 'jacket-adjust',
  bond_level_required: 2,
  daily_mission: 'Send gifts to 3 different angels'
}, {
  id: 'mascha-leather',
  angel_name: 'Mascha',
  skin_name: 'BD-inspired Fashion',
  visual_theme: 'Full-coverage leather catsuit, high boots, gloves, decorative whip, neon night city',
  personality_tone: 'Dominant, mysterious, with a commanding presence',
  currency_type: 'Desire Gems',
  price: 50,
  unlock_method: 'Purchase with Desire Gems or win from Spin Wheel',
  status: 'Locked',
  rarity: 'Legendary',
  time_limited: false,
  countdown: null,
  fomo_label: 'Premium',
  preview_image_url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/45ApDVqx9dar4azjC3q3BF/1d.png',
  short_description: "Surrender to Mascha's control in this dominant ensemble.",
  storyline_piece: "Chapter 3: I invited him to my private club downtown. The look in his eyes when he saw me in my leather outfit was worth every penny. 'Tonight,' I whispered, 'you follow my rules...'",
  tease_animation: 'whip-motion',
  bond_level_required: 4,
  daily_mission: 'Rate 5 photos in the Hot or Not section'
}, {
  id: 'mascha-royal',
  angel_name: 'Mascha',
  skin_name: 'Fantasy Royal',
  visual_theme: 'Deep red and gold embroidered dress, medieval throne room with warm candlelight',
  personality_tone: 'Regal, seductive, with an air of untouchable desire',
  currency_type: 'Desire Gems',
  price: 75,
  unlock_method: 'Purchase with Desire Gems',
  status: 'Locked',
  rarity: 'Legendary',
  time_limited: true,
  countdown: '72:00:00',
  fomo_label: 'Limited Time',
  preview_image_url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7F8hwR6swPZzs8gbocW89M/1b.png',
  short_description: 'Bow before Queen Mascha and earn her royal favor.',
  storyline_piece: "Chapter 4: In my dreams, I'm royalty and he is my loyal subject. I summoned him to my chambers, the candlelight casting shadows across my royal gown. 'Your queen requires your complete devotion tonight...'",
  tease_animation: 'royal-turn',
  bond_level_required: 6,
  daily_mission: null
}, {
  id: 'mascha-tactical',
  angel_name: 'Mascha',
  skin_name: 'Futuristic Tactical',
  visual_theme: 'Sleek black combat suit with neon blue accents, urban cyberpunk background',
  personality_tone: 'Intense, focused, with a dangerous allure',
  currency_type: 'Desire Gems',
  price: 100,
  unlock_method: 'Purchase with Desire Gems or complete all other skins',
  status: 'Locked',
  rarity: 'Legendary',
  time_limited: false,
  countdown: null,
  fomo_label: 'Ultimate Skin',
  preview_image_url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9HGzfiSbdYekUNx9i2xatA/1a.png',
  short_description: 'Join Mascha on a high-stakes mission where danger heightens desire.',
  storyline_piece: "Final Chapter: The mission was dangerous, but the adrenaline only intensified our connection. As we hid from pursuers in that abandoned building, the blue lights of my tactical suit illuminating his face, I pulled him close and whispered, 'If this is our last night...'",
  tease_animation: 'hood-reveal',
  bond_level_required: 8,
  daily_mission: null
}];
// Bond bonus reward after collecting all skins
export const MaschaBondBonus = {
  title: "Mascha's Ultimate Fantasy",
  description: "You've unlocked all of Mascha's personas and completed her intimate storyline. As a reward, you now have access to exclusive AR/VR interactions and Mascha's personal voiceovers.",
  rewards: [{
    type: 'AR/VR Experience',
    name: 'Private Encounter',
    description: 'An exclusive AR/VR interaction with Mascha in your choice of her skins.'
  }, {
    type: 'Voice Pack',
    name: 'Intimate Whispers',
    description: "Mascha's seductive voice responses, personalized with your name."
  }, {
    type: 'Special Mission',
    name: "Mascha's Challenge",
    description: 'A private mission with special rewards, guided by Mascha herself.'
  }]
};
// Daily missions to unlock skins
export const MaschaDailyMissions = [{
  id: 'mission-1',
  title: 'Corporate Admirer',
  description: "Send gifts to 3 different angels to impress Mascha's business side",
  reward: 'Progress toward unlocking Sleek Business skin',
  progress: 0,
  total: 3,
  skinId: 'mascha-business'
}, {
  id: 'mission-2',
  title: 'Dominant Approval',
  description: 'Rate 5 photos in the Hot or Not section to show your taste',
  reward: 'Progress toward unlocking BD-inspired Fashion skin',
  progress: 0,
  total: 5,
  skinId: 'mascha-leather'
}, {
  id: 'mission-3',
  title: 'Royal Tribute',
  description: 'Spend 50 Love Tokens on any content in the marketplace',
  reward: '25% discount on Fantasy Royal skin',
  progress: 0,
  total: 50,
  skinId: 'mascha-royal'
}];
// Spin wheel rewards
export const SpinWheelRewards = [{
  id: 'wheel-1',
  name: 'BD-inspired Fashion Skin',
  type: 'skin',
  probability: 5,
  skinId: 'mascha-leather',
  icon: '👑'
}, {
  id: 'wheel-2',
  name: '30 Love Tokens',
  type: 'tokens',
  probability: 15,
  amount: 30,
  icon: '❤️'
}, {
  id: 'wheel-3',
  name: '15 Desire Gems',
  type: 'gems',
  probability: 10,
  amount: 15,
  icon: '💎'
}, {
  id: 'wheel-4',
  name: 'Tease Preview Unlock',
  type: 'tease',
  probability: 20,
  icon: '👁️'
}, {
  id: 'wheel-5',
  name: '5 Love Tokens',
  type: 'tokens',
  probability: 25,
  amount: 5,
  icon: '❤️'
}, {
  id: 'wheel-6',
  name: 'Better Luck Next Time',
  type: 'nothing',
  probability: 25,
  icon: '🎲'
}];